import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectSurveyTaskServiceCreateResponseJson,
  ProjectSurveyTaskServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedSurveyTaskActions = createActionGroup({
  source: 'PaginatedSurveyTask',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedSurveyTasks': props<{
      params: ProjectSurveyTaskServiceListRequestJson;
    }>(),
    'List PaginatedSurveyTasks Success': props<{
      data: ApiPaginated<ProjectSurveyTaskServiceCreateResponseJson>;
    }>(),
    'List PaginatedSurveyTasks Failure': props<{ error: unknown }>(),
  },
});
